import { Navigate, Route, Routes } from "react-router-dom";

import { RequireAccess } from "@/app/auth/RequireAccess";

import { PaymentNotificationsPage } from "./pages/PaymentNotificationsPage";
import { WalletMovementsPage } from "./pages/WalletMovementsPage";
import { WalletsPage } from "./pages/WalletsPage";

export const WalletsNavigation = () => {
  return (
    <Routes>
      <Route index element={<WalletsPage />} />
      <Route path=":walletId/movements" element={<WalletMovementsPage />} />
      {/* Its own guard: the parent one resolves the `/app/wallets` entry, not this one. */}
      <Route
        path="notifications"
        element={
          <RequireAccess to="/app/wallets/notifications">
            <PaymentNotificationsPage />
          </RequireAccess>
        }
      />
      {/*
        Absolute, not `to=""`. A relative empty target resolves against the LAST contributing match's full
        pathname — splat included (`getResolveToMatches`) — so `to=""` sent `/app/wallets/typo` to itself:
        the wildcard matched again, `<Navigate>`'s effect deps were unchanged so it never re-fired, and the
        route rendered nothing. A wasted history entry and a permanently blank screen.
      */}
      <Route path="*" element={<Navigate to="/app/wallets" replace />} />
    </Routes>
  );
};
